import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Input, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const InviteLink = ({ url, ...containerProps }) => {
  const { t } = useTranslation();
  let inputRef;

  const copyToClipboard = (e) => {
    inputRef.select();
    document.execCommand('copy');
    e.target.focus();
  };

  return (
    <Flex {...containerProps}>
      <Input ref={(ref) => (inputRef = ref)} value={url} readOnly borderRadius={0} />
      <Button
        onClick={copyToClipboard}
        borderRadius={0}
        borderWidth={2}
        bg={null}
        fontWeight="bold"
        color="brand.60"
        borderColor="brand.60"
      >
        {t('interpreter.form.copy')}
      </Button>
    </Flex>
  );
};

InviteLink.propTypes = {
  url: PropTypes.string,
};

InviteLink.defaultProps = {};

export default InviteLink;
